import React from "react";

export default () =>
    <div className="NotFound">
        <h3>Beklager, men siden du leter etter finnes ikke!</h3>
    </div>;